import { types } from 'mobx-state-tree';

import PaymentSeller from './PaymentSeller';

export default types.model('ItemSaleInfo', {
  price: 0,
  title: '',
  description: types.maybeNull(types.string),
  quantity: types.optional(types.number, 1),
  primary_image: '',
  alias: '',
  checkout_url: '',
  viewer_is_owner: false,
  image_list: types.optional(types.array(types.string), []),
  seller: types.optional(PaymentSeller, {}),
});
